const authApiMap = {
  'console.log': 'console.log'
}


export default {
  eval: function (code, params, authApi) {
    // 构造执行环境
    function sandbox(code) {
      code = 'with (sandbox) {' + code + '}'
      const fn = new Function('sandbox', code)
      return function (sandbox) {
        const consoleProxy = new Proxy({}, {
          "has": function (oTarget, sKey) {
            return true;
          },
          "get": function (oTarget, sKey) {
            if (sKey === 'log') {
              return window.console[sKey].bind(sandbox)
            }
            return undefined;
          }
        })
        const sandboxProxy = new Proxy(sandbox, {
          "has": function (oTarget, sKey) {
            return true;
          },
          "get": function (oTarget, sKey) {
            if (sKey === Symbol.unscopables) return undefined
            if (sKey === 'console') {
              return consoleProxy
            }
            return Reflect.get(oTarget, sKey);
          },
        })
        return fn.call(sandbox, sandboxProxy);
      }
    }
    return sandbox(code)(params)
  },
  iframe: function (code, params) {
    const sanboxDiv = document.createElement('div');
    document.body.appendChild(sanboxDiv);

    // 构造执行环境
    function sandbox(code) {
      code = 'with (sandbox) {' + code + '}'
      const fn = new Function('sandbox', code)
      return function (sandbox) {
        const documentProxy = new Proxy(sandbox.document, {
          "get": function (oTarget, sKey) {
            if (sKey === 'body') return sanboxDiv;
            if (typeof Reflect.get(oTarget, sKey) === 'function') {
              return Reflect.get(oTarget, sKey).bind(oTarget);
            }
            return Reflect.get(oTarget, sKey);
          },
        })
        const sandboxProxy = new Proxy(sandbox, {
          "has": function (oTarget, sKey) {
            return true;
          },
          "get": function (oTarget, sKey) {
            if (sKey === Symbol.unscopables) return undefined
            if (sKey === 'document') return documentProxy;
            return Reflect.get(oTarget, sKey);
          },
        })
        return fn(sandboxProxy);
      }
    }

    // 模拟原生浏览器对象
    const frame = document.body.appendChild(document.createElement('iframe'))
    frame.src = 'about:blank';
    frame.style.display = 'none';
    frame.sandbox.add(...['allow-scripts', 'allow-same-origin', 'allow-popups', 'allow-presentation', 'allow-top-navigation'])
    return sandbox(code)(frame.contentWindow)
  }
}